


















































































































































































































































import { PropType } from 'vue';
import { mapActions } from 'vuex';
import { startCase } from 'lodash';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import functions from '@/mixins/functions';

import { QuoteProductCategory } from '@/models/quote';
import {
  ConfigurationItem,
  IConfigurationItem
} from '@/models/configurator/configuration';
import { ErrorManager } from '@/models/error';
import { getCurrencySymbol } from '@/utils/currency';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import { roundCurrency } from '@/utils/helpers';

export default mixins(functions, auth).extend({
  components: { ConfirmationDialog },
  props: {
    item: Object as PropType<ConfigurationItem>,
    quoteProductCategory: Object as PropType<QuoteProductCategory>,
    quoteId: Number,
    quoteRevision: Number,
    exchangeRate: Number,
    currencyCode: String,
    disabled: Boolean,
    onlyUnitCost: Boolean
  },

  data: () => ({
    discountErrors: [] as string[],
    discountLoading: false,

    quantityLoading: false,
    quantityErrors: [] as string[],

    unitPriceLoading: false,
    unitPriceErrors: [] as string[],

    unitCostLoading: false,
    unitCostErrors: [] as string[],

    descriptionLoading: false,
    descriptionErrors: [] as string[],

    errorMessage: '',
    detailErrorMessage: '',
    deleteDialog: false,
    selectedConfigurationItem: null as null | ConfigurationItem,
    deleteInProgress: false
  }),

  computed: {
    isUnitCostDisabled(): boolean {
      if (this.onlyUnitCost) {
        return false;
      }
      return this.disabled;
    }
  },

  methods: {
    getCurrencySymbol,

    startCase,
    roundCurrency,

    ...mapActions({
      updateConfigurationItemDiscount: 'quote/updateConfigurationItemDiscount',
      updateConfigurationItemQuantity: 'quote/updateConfigurationItemQuantity',
      updateConfigurationItemUnitPrice:
        'quote/updateConfigurationItemUnitPrice',
      updateConfigurationItemUnitCost: 'quote/updateConfigurationItemUnitCost',
      deleteConfigurationItem:
        'configuratorConfiguration/deleteConfigurationItem'
    }),

    editItem(item: IConfigurationItem) {
      this.$emit('editItem', item);
    },

    itemDetailClass(item: IConfigurationItem) {
      if (item.is_obsolete) {
        return 'item-row--disabled';
      }
    },

    debounceUpdateUnitPrice(unitPrice: number) {
      this.unitPriceLoading = true;
      this.unitPriceErrors.length = 0;
      return this.debounce(this.updateUnitPrice, 1000)(unitPrice);
    },

    async updateUnitPrice(unitPrice: number) {
      this.item.unit_price = unitPrice;
      try {
        await this.updateConfigurationItemUnitPrice({
          id: this.quoteId,
          revision: this.quoteRevision,
          quoteProductCategory: this.quoteProductCategory.id,
          item: this.item
        }).then(() => {
          // just emit the updateUnitPrice on success
          this.$emit('update');
        });
      } catch (e) {
        this.unitPriceErrors.push('Error updating unit price');
        throw Error('failed to update unit price');
      } finally {
        this.unitPriceLoading = false;
      }
    },

    debounceUpdateUnitCost(unitCost: number) {
      this.unitCostLoading = true;
      this.unitCostErrors.length = 0;
      return this.debounce(this.updateUnitCost, 1000)(unitCost);
    },

    async updateUnitCost(unitCost: number) {
      this.item.unit_cost = unitCost;
      try {
        await this.updateConfigurationItemUnitCost({
          id: this.quoteId,
          revision: this.quoteRevision,
          quoteProductCategory: this.quoteProductCategory.id,
          item: this.item
        }).then(() => {
          // just emit the updateUnitCost on success
          this.$emit('update');
        });
      } catch (e) {
        this.unitCostErrors.push('Error updating unit cost');
        throw Error('failed to update unit cost');
      } finally {
        this.unitCostLoading = false;
      }
    },

    debounceQuantity(value: string) {
      const quantity = Number(value);
      if (isNaN(quantity)) return;
      this.quantityLoading = true;
      this.quantityErrors.splice(0, this.quantityErrors.length);
      return this.debounce(this.updateQuantity, 1000)(quantity);
    },

    async updateQuantity(quantity: number) {
      this.item.quantity = quantity;

      try {
        await this.updateConfigurationItemQuantity({
          id: this.quoteId,
          revision: this.quoteRevision,
          quoteProductCategory: this.quoteProductCategory.id,
          item: this.item
        }).then(() => {
          this.$emit('update');
        });
      } catch (e) {
        this.quantityErrors.push('Error updating quantity');
        throw Error('failed to update Quantity');
      } finally {
        this.quantityLoading = false;
      }
    },

    debounceDiscount() {
      // clear errors without waiting for debounce
      this.discountErrors.length = 0;

      // Call updateDiscount 1 second the last time this function is called
      this.discountLoading = true;

      return this.debounce(this.updateDiscount, 1000)();
    },

    async updateDiscount() {
      try {
        // validate discount should be from rules?
        // validateDiscount(discount);
        // TODO: update this to use specifc endpoint for discount
        await this.updateConfigurationItemDiscount({
          id: this.quoteId,
          revision: this.quoteRevision,
          quoteProductCategory: this.quoteProductCategory.id,
          item: this.item
        }).then(() => {
          // just emit the updateDiscount on success
          this.$emit('update');
        });
      } catch (e) {
        this.discountErrors.push('Error updating discount');
        throw Error('failed to update Discount');
      } finally {
        this.discountLoading = false;
      }
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    removeConfigurationItem(item: ConfigurationItem) {
      this.clearAllErrors();
      this.deleteInProgress = true;

      this.deleteConfigurationItem(item)
        .then(() => {
          this.deleteDialog = false;
          // just emit the update on success
          this.$emit('update');
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        })
        .finally(() => {
          this.deleteInProgress = false;
        });
    },

    cancelItemConfigurationItemDeleteDialog() {
      this.clearAllErrors();
      this.selectedConfigurationItem = null;
      this.deleteDialog = false;
    },

    openItemConfigurationItemDeleteDialog(
      itemConfigurationItem: ConfigurationItem
    ) {
      this.selectedConfigurationItem = itemConfigurationItem;

      this.deleteDialog = true;
    }
  }
});
